import { render, staticRenderFns } from "./BrokerPreRegisterDataList.vue?vue&type=template&id=5fefda62"
import script from "./BrokerPreRegisterDataList.vue?vue&type=script&lang=js"
export * from "./BrokerPreRegisterDataList.vue?vue&type=script&lang=js"
import style0 from "./BrokerPreRegisterDataList.vue?vue&type=style&index=0&id=5fefda62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports